import { render, staticRenderFns } from "./TaskItemOptions.vue?vue&type=template&id=43cf258c&"
import script from "./TaskItemOptions.vue?vue&type=script&lang=js&"
export * from "./TaskItemOptions.vue?vue&type=script&lang=js&"
import style0 from "./TaskItemOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports